"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Landing = exports.LanguageContext = void 0;
const react_1 = __importStar(require("react"));
const Landing_elements_1 = require("./Landing.elements");
const components_1 = require("./components");
const AreYouPatientPopUp_1 = require("@app/routes/Landing/components/MainLanding/components/AreYouPatientPopUp");
const react_intersection_observer_1 = require("react-intersection-observer");
const js_cookie_1 = __importDefault(require("js-cookie"));
exports.LanguageContext = (0, react_1.createContext)(null);
const Landing = ({}) => {
    const [popUpOpen, setPopUpOpen] = (0, react_1.useState)(false);
    const [currentPage, setCurrentPage] = (0, react_1.useState)("main");
    const timerRef = (0, react_1.useRef)();
    const [language, setLanguage] = (0, react_1.useState)("en");
    const extraContentRef = (0, react_1.useRef)(null);
    (0, react_1.useLayoutEffect)(() => {
        const langId = js_cookie_1.default.get("lang_id");
        setLanguage(Number(langId) === 1 ? "ru" : "en");
    }, []);
    (0, react_1.useEffect)(() => {
        if (currentPage === "main") {
            timerRef.current = setTimeout(() => setPopUpOpen(true), 60000);
            return () => clearTimeout(timerRef.current);
        }
    }, []);
    const setInView = (inView) => {
        if (inView) {
            clearTimeout(timerRef.current);
            setTimeout(() => {
                setPopUpOpen(true);
            }, 300);
        }
    };
    const showExtraContent = (forWhom) => {
        setCurrentPage(forWhom);
        setTimeout(() => {
            extraContentRef.current.scrollIntoView({
                behavior: "smooth",
            });
        }, 300);
        setPopUpOpen(false);
    };
    return (react_1.default.createElement(exports.LanguageContext.Provider, { value: language },
        react_1.default.createElement(Landing_elements_1.LandingWrap, null,
            react_1.default.createElement(components_1.MainLanding, null),
            react_1.default.createElement(react_intersection_observer_1.InView, { onChange: setInView, triggerOnce: true, threshold: 1 }),
            react_1.default.createElement("div", { ref: extraContentRef },
                currentPage === "patient" && react_1.default.createElement(components_1.PatientLanding, null),
                currentPage === "therapist" && react_1.default.createElement(components_1.TherapistLanding, null)),
            popUpOpen && (react_1.default.createElement(AreYouPatientPopUp_1.AreYouPatientPopUp, { onClose: () => setPopUpOpen(false), openPatientLanding: () => showExtraContent("patient"), openTherapistLanding: () => showExtraContent("therapist") })))));
};
exports.Landing = Landing;
